export default {
  fr: "/",
  de: "/de-de",
  nl: "/nl-nl",
  en: "/en-en",
  it: "/it-it",
  es: "/es-es",
  pt: "/pt-pt",
};
